import React, { useEffect } from 'react'
import gsap from 'gsap'
import ScrollSmoother from 'gsap/ScrollSmoother'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'

gsap.registerPlugin(useGSAP)
gsap.registerPlugin(ScrollSmoother)
gsap.registerPlugin(ScrollTrigger)

export const Layout = ({ className, children }) => {
  useEffect(() => {
    setTimeout(() => document.querySelectorAll('header > div > nav,.logo,.navigation-menu > button').forEach(element => element.classList.remove('inverse')))

    // add a class to allow hiding the fixed hero section so it doesn't appear on mobile when it overscrolls at the end of the page
    document.body.classList.remove('scrolled')
    const applyScrollClass = () => document.body.classList[window.scrollY > 3000 ? 'add' : 'remove']('scrolled')
    window.addEventListener('scroll', applyScrollClass)
    return () => window.removeEventListener('scroll', applyScrollClass)
  }, [])

  useGSAP(() => {
    gsap.matchMedia().add('(min-width: 500px)', () => {
      ScrollSmoother.create({
        smooth: 1,
        wrapper: '#smooth-wrapper'
      })
      ScrollTrigger.normalizeScroll(true)
    })

    setTimeout(() => ScrollTrigger.refresh(), 1000)
  })

  return (
    <article className={className}>
      {children}
    </article>
  )
}

export const PageHead = ({ title }) => <>
  <title>Pod&Hive{title ? ' - ' + title : ''}</title>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600" rel="stylesheet" />
  <meta name="description" content="Seriously fun and engaging learning games and tools for your workshops, corporate training, offsites and conferences." />
</>